import { GDPRModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<GDPRModel>('/ipad/children/gdpr');
export default api;
